/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class IdentityProvidersNames {
  /**
  * The list of available providers for the customer
  */
  'providers'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providers",
      "baseName": "providers",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IdentityProvidersNames.attributeTypeMap;
  }

  public constructor() {
  }
}

